import { store, categoryStore, reviewStore } from '@/store';
import {
    DEFAULT_TRAFFIC_SOURCE,
    TRAFFIC_SOURCE_EXOCLICK,
    ADBLOCK_EXOCLICK,
    TRAFFIC_SOURCE_PROPELLER,
    ADBLOCK_PROPELLER,
} from '@/constants';
import { routeMixin } from './route';

export const rankingMixin = {
    mixins: [routeMixin],
    methods: {
        async getCategory() {
            let trafficSource = DEFAULT_TRAFFIC_SOURCE;
            const category = this.getCategorySlug();
            let uT = '1';
            let brVersion = '';
            let clId = '';

            if (this.$globalState.trafficSource !== null) {
                trafficSource = this.$globalState.trafficSource;
            } else {
                trafficSource = document
                    .querySelector('#main-ts')
                    .getAttribute('data-ts');
                this.$globalState.trafficSource = trafficSource;
            }

            if (TRAFFIC_SOURCE_EXOCLICK === trafficSource) {
                trafficSource = ADBLOCK_EXOCLICK;
            }
            if (TRAFFIC_SOURCE_PROPELLER === trafficSource) {
                trafficSource = ADBLOCK_PROPELLER;
            }

            const hasAbRank = !!this.$route.query.arnk;
            const t = this.$globalConstants.userId;

            if (this.$globalConstants.user.userTimezone !== null) {
                uT = this.$globalConstants.user.userTimezone;
            }
            if (this.$route.query.brnkv) {
                brVersion = this.$route.query.brnkv;
            }
            if (this.$globalConstants.clickinId) {
                clId = this.$globalConstants.clickinId;
            }
            let uA = '';
            let uG = '';
            const user = this.$globalConstants.user;

            if (user) {
                if (user.age !== null && user.age !== undefined) {
                    uA = user.age;
                }

                if (user.gender !== null && user.gender !== undefined) {
                    uG = user.gender;
                }
            }

            let url = `/host/${this.$globalConstants.host['id']}/category/${trafficSource}/${category}?arnk=${hasAbRank}&fp=${this.$globalState.fixedPosition}&t=${t}&uT=${uT}&brnkv=${brVersion}&clId=${clId}&uA=${uA}&uG=${uG}`;

            url = url + '&device_type=' + this.$globalConstants.deviceType;

            // temp until our CMS is connected with the new RankingSource
            if ('1' === this.$route.query.brnk) {
                url = url + '&brnk=' + this.$route.query.brnk;
            }

            if (
                window.__partner_rankings__ &&
                Object.keys(window.__partner_rankings__).length > 0
            ) {
                this.processResponse(window.__partner_rankings__);
                window.__partner_rankings__ = null;
            } else {
                await window.axios.get(url).then((response) => {
                    this.processResponse(response.data);
                });
            }
        },
        processResponse(data) {
            this.partners = data.partners;
            this.category = data.category;
            store.setPsh(data.partnerSet);
            store.setPageViewId(data.page_view_id);
            reviewStore.setReviewPartners(data.partners_review);
            categoryStore.setCategory(data.category);
            categoryStore.updateRankingList(data.partners);
        },
    },
};
